export default __webpack_public_path__ + "assets/images/icon-pause.e0650df5d9318c5bd1ba9d65dd1b27ac.svg";